import { useState } from 'react';
import { useIntl } from '@leagueplatform/locales';
import { STEP_STRING_IDS } from 'components/onboarding-account-setup/onboarding-account-setup.constants';
import { StepScreen } from 'components/step-screen/step-screen.component';
import { useStepNavigation } from 'components/stepper/stepper.component';
import { useOnboardingError } from 'components/onboarding-account-setup/contexts/onboarding-error.context';
import {
  useOnboardingFormActions,
  useOnboardingFormState,
} from 'components/onboarding-account-setup/contexts/onboarding-form.context';
import { CodeVerificationInput } from './code-verfication-input.component';

export const CodeVerificationStep = () => {
  const { formatMessage } = useIntl();
  const { goToNextStep, goToPreviousStep } = useStepNavigation();
  const { reportError } = useOnboardingError();
  const { submitVerificationCode } = useOnboardingFormActions();
  const {
    verifyOtpStatus: { isPending },
  } = useOnboardingFormState();
  const [serverErrorMessage, setServerErrorMessage] = useState<string>();

  const handleSubmit = async () => {
    setServerErrorMessage(undefined);

    try {
      const result = await submitVerificationCode();
      if (!result) return;

      if (result.success) {
        goToNextStep();
      } else {
        setServerErrorMessage(
          result.message ||
            formatMessage({
              id: 'STR_ONBOARDING_ACCOUNT_SETUP_VALIDATION_CODE_INVALID',
            }),
        );
      }
    } catch (err) {
      reportError(err as Error);
    }
  };

  return (
    <StepScreen
      heading={formatMessage({ id: STEP_STRING_IDS.verify.heading })}
      subHeading={formatMessage({ id: STEP_STRING_IDS.verify.subHeading })}
      primaryButton={{
        label: formatMessage({ id: STEP_STRING_IDS.verify.primaryButtonLabel }),
        onClick: handleSubmit,
        isButtonLoading: isPending,
      }}
      secondaryButton={{
        label: formatMessage({
          id: STEP_STRING_IDS.verify.secondaryButtonLabel,
        }),
        onClick: goToPreviousStep,
      }}
    >
      <CodeVerificationInput
        serverErrorMessage={serverErrorMessage}
        onCodeChange={() => setServerErrorMessage(undefined)}
      />
    </StepScreen>
  );
};
